<div [class.container-card-counter-not-img]="!block.immagine" [class.container-card-counter]="block.immagine"
    *ngIf="block" [ngClass]="{'active-card': isActiveCarousel}" class="no-print">
    <div class="position-relative" [class.container-card-counter-not-img__box-card]="!block.immagine"
        [class.container-card-counter__box-card]="block.immagine">
        <div [class.container-card-counter-not-img__box-card__img]="!block.immagine"
            [class.container-card-counter__box-card__img]="block.immagine">
            <img loading="lazy" *ngIf="block.immagine" [src]="imgPath" [alt]="block.testo_alt">
            <!-- <img loading="lazy" *ngIf="!block.immagine" src="../../../../../assets/images/rectangle_gradient.png" alt="gradient-image"> -->
        </div>
        <p *ngIf="block.numero" [class.container-card-counter-not-img__box-card__number]="!block.immagine"
            [class.container-card-counter__box-card__number]="block.immagine"
            class="text-garamond m-0 position-absolute text-uppercase" [innerHTML]="block.numero"></p>
    </div>
    <div *ngIf="block.descrizione" class="container-card-counter__box-card__description ls-label-medium text-brand-10"
        [innerHTML]="block.descrizione"></div>
</div>
<app-sample-print [title]="block.numero" [description]="block.descrizione"></app-sample-print>